import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import Confetti from "react-confetti";
import { useNavigate } from "react-router-dom";
import GuestLayout from "../../../../layouts/GuestLayout";

const SuccessView: React.FC = () => {
  const navigate = useNavigate();
  const [dimensions, setDimensions] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <GuestLayout>
      <div className="flex items-center justify-center p-4">
        <Confetti
          width={dimensions.width}
          height={dimensions.height}
          recycle={false}
          numberOfPieces={500}
          tweenDuration={10000}
        />
        <div className="common_card text-center p-8 flex flex-col items-center justify-center" style={{ width: 'min(500px, 90vw)' }}>
          <FontAwesomeIcon icon={faCheckCircle} className="text-green-500 mb-4" style={{ fontSize: "4rem" }} />
          <h2 className="text-2xl font-bold mb-2">All Done!</h2>
          <div className="text-muted mb-4 text-left">
            <p className="mb-3">You have successfully signed the document. A confirmation email has been sent to you for your records.</p>
            <p className="mb-3">Once all other parties have signed, you will receive a final copy.</p>
            <h4 className="font-semibold text-gray-700 mt-4 mb-2">What's Next?</h4>
            <ul className="list-disc list-inside space-y-2 text-sm">
              <li>A finalized copy of the fully signed document.</li>
              <li>An audit file that details the signing process for compliance purposes.</li>
            </ul>
            <p className="mt-4">No further action is required on your part. Thank you!</p>
          </div>
          <Button variant="primary" onClick={() => navigate('/dashboard')}>
            Go to dashboard
          </Button>
        </div>
      </div>
    </GuestLayout>
  );
};

export default SuccessView;
